import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import {
    Clock, MapPin, LogIn, LogOut, AlertTriangle, CalendarClock, Building2,
} from "lucide-react";

const KEY_PREFIX = "ss_timbratura_guide_seen_";

export function hasSeenTimbraturaGuide(userId) {
    if (!userId) return true;
    try {
        return localStorage.getItem(KEY_PREFIX + userId) === "1";
    } catch {
        return true;
    }
}

export function markTimbraturaGuideSeen(userId) {
    if (!userId) return;
    try {
        localStorage.setItem(KEY_PREFIX + userId, "1");
    } catch {
        /* ignore */
    }
}

const STEPS = [
    {
        icon: MapPin,
        title: "Consenti la posizione GPS",
        text: "Alla prima timbratura il telefono chiede il permesso per la posizione: premi \u201cConsenti\u201d. Senza GPS non è possibile timbrare.",
    },
    {
        icon: Building2,
        title: "Controlla il riquadro informativo",
        text: "In alto vedi cliente, cantiere e attività previsti in base alla tua posizione e all'orario: così sai subito dove risulti assegnato.",
    },
    {
        icon: LogIn,
        title: "Timbra l'ENTRATA all'arrivo",
        text: "Quando arrivi sul posto di lavoro premi il pulsante verde ENTRATA. Devi trovarti dentro l'area del cantiere: il sistema riconosce da solo il cantiere più vicino.",
    },
    {
        icon: LogOut,
        title: "Timbra l'USCITA a fine turno",
        text: "Prima di andare via premi USCITA. Senza uscita il turno resta aperto e le ore non vengono conteggiate correttamente.",
    },
    {
        icon: AlertTriangle,
        title: "Fuori orario o fuori area",
        text: "Se timbri in ritardo, in anticipo o fuori dall'area, ti verrà chiesta una breve motivazione che arriva all'ufficio: serve solo per gestire le anomalie.",
    },
    {
        icon: CalendarClock,
        title: "Ore, richieste e area personale",
        text: "Col pulsante \u201cPortale\u201d in alto passi alla tua area personale: in \u201cLe mie ore\u201d trovi il riepilogo mensile (anche in vista calendario) e da \u201cRichieste\u201d invii ferie, permessi e straordinari.",
    },
];

export function TimbraturaGuideDialog({ open, onClose, userId }) {
    const handleClose = () => {
        if (userId) markTimbraturaGuideSeen(userId);
        onClose();
    };

    return (
        <Dialog open={open} onOpenChange={(o) => { if (!o) handleClose(); }}>
            <DialogContent
                className="flex max-h-[88vh] w-[calc(100vw-2rem)] max-w-md flex-col gap-0 overflow-hidden p-0"
                data-testid="timbratura-guide-dialog"
            >
                <DialogHeader className="flex-shrink-0 bg-gradient-to-br from-[#15498F] to-[#376DB3] px-5 py-4 text-white">
                    <DialogTitle className="flex items-center gap-2.5 text-white">
                        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/20 backdrop-blur">
                            <Clock className="h-5 w-5" />
                        </div>
                        <div>
                            <div className="font-display text-lg font-bold">Come si timbra</div>
                            <div className="text-[11px] font-normal text-white/80">Guida rapida alla timbratura geolocalizzata</div>
                        </div>
                    </DialogTitle>
                </DialogHeader>
                <div className="min-h-0 flex-1 space-y-3.5 overflow-y-auto px-5 py-4">
                    {STEPS.map((s, i) => (
                        <div key={s.title} className="flex items-start gap-3" data-testid={`timbratura-guide-step-${i + 1}`}>
                            <div className="mt-0.5 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-[#376DB3]/10 text-[#376DB3]">
                                <s.icon className="h-4 w-4" />
                            </div>
                            <div>
                                <div className="text-sm font-bold text-slate-800">{i + 1}. {s.title}</div>
                                <p className="mt-0.5 text-[13px] leading-relaxed text-slate-600">{s.text}</p>
                            </div>
                        </div>
                    ))}
                    <p className="rounded-md bg-slate-50 px-3 py-2 text-xs text-slate-500">
                        Trovi questa guida anche in PDF tra i tuoi documenti e puoi riaprirla dal pulsante <b>Guida</b> in alto.
                    </p>
                </div>
                <div className="flex-shrink-0 border-t border-slate-100 px-5 py-3">
                    <Button
                        onClick={handleClose}
                        className="w-full bg-[#376DB3] text-white hover:bg-[#2c5a96]"
                        data-testid="timbratura-guide-close-btn"
                    >
                        Ho capito, iniziamo
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
